import { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ThemeProvider } from './context/ThemeContext';

import AppLayout from './components/layout/AppLayout';
import RateLimitNotice from './components/ui/RateLimitNotice';

const Login = lazy(() => import('./pages/auth/Login'));
const Profile = lazy(() => import('./pages/auth/Profile'));
const Dashboard = lazy(() => import('./pages/dashboard/Dashboard'));
const Users = lazy(() => import('./pages/users/Users'));
const Companies = lazy(() => import('./pages/companies/Companies'));
const Documents = lazy(() => import('./pages/documents/Documents'));
const Comments = lazy(() => import('./pages/comments/Comments'));
const Permissions = lazy(() => import('./pages/permissions/Permissions'));
const TaskWorkspace = lazy(() => import('./pages/tasks/TaskWorkspace'));
const AssignedTasks = lazy(() => import('./pages/tasks/AssignedTasks'));
const DirectChat = lazy(() => import('./pages/chat/DirectChat'));
const DocCategories = lazy(() => import('./pages/categories/DocCategories'));

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <RateLimitNotice />
            <Suspense fallback={null}>
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route element={<AppLayout />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/documents" element={<Documents />} />
                  <Route path="/comments" element={<Comments />} />
                  <Route path="/tasks" element={<AssignedTasks />} />
                  <Route path="/tasks/:id" element={<TaskWorkspace />} />
                  <Route path="/permissions" element={<Permissions />} />
                  <Route path="/chat" element={<DirectChat />} />
                  <Route path="/doc-categories" element={<DocCategories />} />
                  <Route path="/profile" element={<Profile />} />
                </Route>

                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Suspense>
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
